<template>
  <div id="app">
    <comheader></comheader>
    <router-view class="view_box"></router-view>
    <comfooter></comfooter>
  </div>
</template>

<script>
import comheader from './components/comheader.vue'
import comfooter from './components/comfooter.vue'
export default {
  name: 'App',
  components:{comheader,comfooter}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue